import { Component, OnInit } from '@angular/core';
import { constants } from '../constants';
import { CommonUtilitiesService } from '../common-utilities.service';
import { CombosService } from './combos.service';
import { Router } from '@angular/router';
import * as $ from 'jquery';

//jquery var
declare var $: any;

@Component({
  selector: 'app-combos',
  templateUrl: './combos.component.html',
  styleUrls: ['./combos.component.scss']
})
export class CombosComponent implements OnInit {
  public BONOS: string = constants.FROM_BONOS_PAGE;
  public CARE_CHANNELS_TITLE: string = this.LANG.getLangText("CARE_CHANNELS_FOOTER_TITTLE_GENERIC");

  combosList = [];
  bonusesList = [];
  finalComboList =  [];
  isComboShow = true;

  //constantes para la pantalla
  catBra = constants.COMBO_CATEGORY_BRAND;
  catMou = constants.COMBO_CATEGORY_MOUNT;
  catExp = constants.COMBO_CATEGORY_EXPRESS;

  constructor(public LANG: CommonUtilitiesService, private combosService: CombosService, private _router: Router) { }

  ngOnInit() {
     //mostrar parte superior
    $("html, body").animate({ scrollTop: 0 }, "slow");
    this.getComboList();
    if(this._router.url === constants.ROUTE_URL_BONUS){
      this.switchTab(false);
    }
  }

  /**
   * Description: Método que obtiene los combos generales
   * Autor: Diego Diaz
   * @param N/A
   * @return N/A
   */
  getComboList() {
    //Obtiene los combos recomendados
    this.combosService.getCombosList().subscribe((dataInfo => {
      if (dataInfo['responseCode'] == constants.SUCCESS_WS_RESPONSE_CODE) {
        this.combosList = dataInfo['obj'];

        let catComListMax = [];
        let catComListMou = [];
        let catComListExp = [];
        for (var k in this.combosList) {
          if(this.combosList[k].category == constants.COMBO_CATEGORY_BRAND){
            catComListMax.push(this.combosList[k]);
          }else if(this.combosList[k].category == constants.COMBO_CATEGORY_MOUNT){
            catComListMou.push(this.combosList[k]);
          }else if(this.combosList[k].category == constants.COMBO_CATEGORY_EXPRESS){
            catComListExp.push(this.combosList[k]);
          }
        }
        this.finalComboList.push(catComListMax);
        this.finalComboList.push(catComListMou);
        this.finalComboList.push(catComListExp);
      }
    }),
      (err) => {
        this.combosList = [];
      });


    //Obtiene los combos recomendados
    this.combosService.getBonusesList(false).subscribe((dataInfo => {
      if (dataInfo['responseCode'] == constants.SUCCESS_WS_RESPONSE_CODE) {
        this.bonusesList = [];
        for (var k in dataInfo['obj']) {
          dataInfo['obj'][k].nslist = dataInfo['obj'][k].socialNet.split("-");
          this.bonusesList.push(dataInfo['obj'][k]);
        }
      }
    }),
      (err) => {
        this.bonusesList = [];
      });

  }

/**
     * Description: Método que crea el titulo segun la categoria
     * Autor: Diego Diaz
     * @param cat categoria a mostrar
     * @return titulo
     */
  getTitleByCategory(cat){
    let title = this.LANG.getLangText("COMBOS_LABEL_TITLE_EXPRESS");
    if(cat == constants.COMBO_CATEGORY_BRAND){
      title = this.LANG.getLangText("COMBOS_LABEL_TITLE_BRAND");
    }else if(cat == constants.COMBO_CATEGORY_MOUNT){
      title = this.LANG.getLangText("COMBOS_LABEL_TITLE_MOUNT");
    }
    return title;
  }


  /**
     * Description: Método que muestra los combos o bonos en las tabs
     * Autor: Diego Diaz
     * @param id tipo de pestaña a mostrar
     * @return N/A
     */
  switchTab(isShow) {
    this.isComboShow = isShow;
  }

    /**
   * Description: Método que muestra el wizard de pagos
   * Autor: Diego Diaz
   * @param comboJson información del Combo/bono a comprar
   * @return N/A
   */
  showPaymentWizard(comboJson){
    localStorage.setItem("shoppingCart", JSON.stringify(comboJson));
    this._router.navigate([constants.ROUTE_URL_PAYMENT_COMBOS]);    
  }

  getSpecialCharacter(input){
    let specialCharacter = "<#>";
    return input.replace(specialCharacter, "");
  }
}
